var map = {
	"./app-google-da-DK.svg": 42471,
	"./app-google-de-DE.svg": 35157,
	"./app-google-en-GB.svg": 78391,
	"./app-google-en-US.svg": 74400,
	"./app-google-es-ES.svg": 35671,
	"./app-google-es-MX.svg": 97220,
	"./app-google-fr-FR.svg": 8459,
	"./app-google-it-IT.svg": 65277,
	"./app-google-nb-NO.svg": 23526,
	"./app-google-nl-NL.svg": 54723,
	"./app-google-pl-PL.svg": 72391,
	"./app-google-pt-BR.svg": 21959,
	"./app-google-pt-PT.svg": 12343,
	"./app-google-sv-SE.svg": 61830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16553;